import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    productdetail: {
        inventory_id:"",
        item_name: "",
        item_description: "",
        item_category: "",
        item_criteria: "",
        images: [],
        item_details: "",
        // product_group_id: "",
        capacitydetails: [{ 
            item_price: "",
            item_available: true,
            item_capacity: "",
            item_quantity: "",
            item_tax: "",
            item_selling_price: "",
            item_offers_price: 0.00,
            capacityValue: "",
            unit: "",
            extraPercentage : "",
            availability_type : "",
            available_from : "",
            available_to : ""
        }]
    },
    edit:false,
    products: [],
    modal: false,
    loading:false,
    selectedCapacity:{},
    kioskProducts:[],
    scannerDeviceId: null,
    scannedProducts: [] // Array of scanned products for bulk upload
};


const productsReducer = createSlice({
    name: "productsReducer",
    initialState: initialState,
    reducers: {
        updateProductDetail: (state, { type, payload }) => {
            state.productdetail = payload
        },
        updateProducts: (state, { type, payload }) => {
            state.products = payload
        },
        updateModal: (state, { type, payload }) => {
            state.modal = payload
        },
        updateEdit: (state, { payload }) => {
            state.edit = payload
        },
        updateLoadingProducts: (state, { type, payload }) => {
            state.loading = payload
        },
        updateSelectedCapacity:(state, action) => {
            state.selectedCapacity = action.payload
          },
        updateKioskProduct:(state, action) => {
            state.kioskProducts = action.payload
          },
        addScannedProduct:(state, action) => {
            const product = action.payload;
            // Check if product already exists (by barcode or name)
            const exists = state.scannedProducts.some(p => 
                (p.sku_code && p.sku_code === product.sku_code) || 
                (p.item_name && p.item_name === product.item_name)
            );
            if (!exists) {
                state.scannedProducts.push({
                    ...product,
                    id: Date.now(), // temporary ID
                    scannedAt: new Date().toISOString()
                });
            }
        },
        removeScannedProduct:(state, action) => {
            state.scannedProducts = state.scannedProducts.filter(p => p.id !== action.payload);
        },
        updateScannedProduct:(state, action) => {
            const { id, updates } = action.payload;
            const index = state.scannedProducts.findIndex(p => p.id === id);
            if (index !== -1) {
                state.scannedProducts[index] = { ...state.scannedProducts[index], ...updates };
            }
        },
        clearScannedProducts:(state) => {
            state.scannedProducts = [];
        },
    }
})

export const { updateProducts, updateModal, updateProductDetail ,updateEdit ,updateLoadingProducts,updateSelectedCapacity,updateKioskProduct, addScannedProduct, removeScannedProduct, updateScannedProduct, clearScannedProducts} = productsReducer.actions



export default productsReducer.reducer;